import {checkAndUpdateToken} from "./auth";
import {
    METHOD_PLAN_YEARS,
    METHPLAN_1,
    METHPLAN_2,
    METHPLAN_3,
    METHPLAN_4,
    SET_METHPLAN_LOADING
} from "./types";
import {BACKEND_URL_PREFIX} from "../utils/const";
import {buildDefaultHeaders} from "./helper";
import {createNotification} from "../components/notifications/notifications";

export const getMethPlanYears = () => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        const response = await fetch(`${BACKEND_URL_PREFIX}/methodical_plan/years`, buildDefaultHeaders(getState));

        dispatch({type: METHOD_PLAN_YEARS, response});

        if (response.ok) {
            const result = await response.json();
            dispatch({type: METHOD_PLAN_YEARS, payload: result});
        }
    }
};

export const getMethPlan_1 = (yearID) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: SET_METHPLAN_LOADING, payload: true});
        try {
            const response = await fetch(`${BACKEND_URL_PREFIX}/methodical_plan/goals_and_objectives/${yearID}`, buildDefaultHeaders(getState));
            const result = await response.json();
            if (response.ok) {
                dispatch({type: METHPLAN_1, payload: result});
            } else {
                createNotification('error', result.error)
            }
        } catch (ERR) {} finally {
            dispatch({type: SET_METHPLAN_LOADING, payload: false});
        }
    }
};

export const getMethPlan_2 = (yearID) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: SET_METHPLAN_LOADING, payload: true});
        try {
            const response = await fetch(`${BACKEND_URL_PREFIX}/methodical_plan/decree/${yearID}`, buildDefaultHeaders(getState));
            const result = await response.json();
            if (response.ok) {
                dispatch({type: METHPLAN_2, payload: result});
            } else {
                createNotification('error', result.error)
            }
        } catch (ERR) {} finally {
            dispatch({type: SET_METHPLAN_LOADING, payload: false});
        }
    }
};

export const getMethPlan_3 = (yearID) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: SET_METHPLAN_LOADING, payload: true});
        try {
            const response = await fetch(`${BACKEND_URL_PREFIX}/methodical_plan/content_part/${yearID}`, buildDefaultHeaders(getState));
            const result = await response.json();
            if (response.ok) {
                dispatch({type: METHPLAN_3, payload: result});
            } else {
                createNotification('error', result.error)
            }
        } catch (ERR) {} finally {
            dispatch({type: SET_METHPLAN_LOADING, payload: false});
        }
    }
};

export const getMethPlan_4 = (yearID) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: SET_METHPLAN_LOADING, payload: true});
        try {
            const response = await fetch(`${BACKEND_URL_PREFIX}/methodical_plan/changes/${yearID}`, buildDefaultHeaders(getState));
            const result = await response.json();
            if (response.ok) {
                dispatch({type: METHPLAN_4, payload: result});
            } else {
                createNotification('error', result.error)
            }
        } catch (ERR) {} finally {
            dispatch({type: SET_METHPLAN_LOADING, payload: false});
        }
    }
};

export const getMethPlanTrash = () => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: METHPLAN_1, payload: null});
        dispatch({type: METHPLAN_2, payload: null});
        dispatch({type: METHPLAN_3, payload: null});
    }
};